import { DeleteOutlined, EditOutlined, EyeOutlined } from '@ant-design/icons';
import { Card, Col, Empty, Row, Typography } from 'antd';
import React from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { GetDocumentLink } from 'store/actions/complianceActions';

const { Title } = Typography;

const Documents = (props) => {
    const { items, openEditModal, deleteModal } = props;

    const dispatch = useDispatch();

    const getDocumentLink = async (id) => {
        const res = await dispatch(GetDocumentLink('onboarding', id));
        if (res?.success) {
            window.open(res?.data, '_blank');
        } else {
            toast.error('Something went wrong!');
        }
    };

    return (
        <>
            {items?.length ? (
                <Row wrap gutter={24}>
                    {items
                        ?.sort((a, b) => a?.id - b?.id)
                        ?.map((item, index) => (
                            <React.Fragment key={index}>
                                <Col xs={24} md={12} lg={8} xxl={6} style={{ marginBottom: '1rem' }}>
                                    <Card
                                        loading={false}
                                        actions={[
                                            <EyeOutlined key="view" onClick={() => getDocumentLink(item?.id)} />,
                                            <EditOutlined key="edit" onClick={() => openEditModal(item)} />,
                                            <DeleteOutlined key="delete" onClick={() => deleteModal(item)} />,
                                        ]}
                                    >
                                        <Title level={5} style={{ textAlign: 'center' }}>
                                            {item?.name}
                                        </Title>
                                    </Card>
                                </Col>
                            </React.Fragment>
                        ))}
                </Row>
            ) : (
                <Row justify="center">
                    <Col>
                        <Empty
                            description={
                                <div>
                                    <h3>No Item</h3>
                                    <span>Add a new item </span>
                                </div>
                            }
                        />
                    </Col>
                </Row>
            )}
        </>
    );
};

export default Documents;
